<template lang="html">
    <div class="repair">
        <div class="banner-img">
        </div>
        <div class="online">
            <form @submit.prevent="submit">
                <h2>在线留言</h2>
                <p>确保迅速、准确、有效的处理故障设备, 减少其负面影响与损失</p>
                <p>咨询热线：<span>400-058-0200</span></p>
                <div class="form">
                    <input type="text" v-model="user.name" placeholder="您的姓名：">
                    <input type="text" v-model="user.email" placeholder="E-mail：">
                    <input type="text" v-model="user.phone" placeholder="您的电话：">
                    <input type="text" v-model="user.qq" placeholder="QQ：">
                    <input type="text" v-model="user.unit" placeholder="所属单位：">
                    <textarea name="name" rows="3" v-model="user.content" placeholder="内容"></textarea>
                </div>
                <button type="submit" name="button">提交</button>
            </form>
        </div>
        <Foot></Foot>
        <dialog-bar v-model="sendVal" type="confirm" title="提示" :content="message" ></dialog-bar>
    </div>
</template>

<script>
import axios from 'axios'
import dialogBar from '@/components/dialog.vue'
import Foot from '@/components/Footer.vue'
export default {
  name: 'service',
  data(){
      return{
          user:{
              name:'',
              email:'',
              phone:'',
              qq:'',
              unit:'',
              content:''
          },
          sendVal: false,
          message:''
      }
  },
  methods:{
    submit:function(){
        if(this.user.name==''){
            this.message='请填写您的姓名'
            this.sendVal=true
            return false
        }
        if(this.user.phone==''){
            this.message='请填写您的电话'
            this.sendVal=true
            return false
        }
        if(this.user.content==''){
            this.message='请填写您的留言'
            this.sendVal=true
            return false
        }
        let formData = JSON.stringify(this.user);
        axios.post('/api/oAuth/saveMsg', this.user).then((res)=>{
            this.message='提交成功'
            this.sendVal=true
        }).catch(function(err){
            console.log(err)
        })
    }
  },
  components: {
      Foot,
      'dialog-bar': dialogBar,
  }
}
</script>

<style lang="scss" scoped>
    .repair{
        .banner-img{
            background: url('https://static.qyjmed.com/webSite/contactUs/repairs/bg.png') center;
            height: 665px;
            margin-top: $highlight-height;
        }
        .online{
            margin:-240px 10% 100px;
            height: 860px;
            background: white;
            text-align: center;
            box-shadow: -5px 5px 24px -4px #a09bd826, 5px -5px 24px -4px #a09bd826;
            h2{
                font-size: 36px;
                color: #060008;
                padding-top: 70px;
                font-weight: 400;
                margin-bottom: 40px;
            }
            >p{
                color: #6E6D70;
                font-size: 18px;
                line-height: 30px;
                span{
                    color: #52B2F2;
                }
            }
            .form{
                margin-top: 48px;
                input{
                    width: 40%;
                    color: #6E6D70;
                    border: 1px solid #e1e1e1;
                    font-size: 18px;
                    padding:16px 2%;
                    margin-bottom: 18px;
                    &:nth-child(2n+1){
                        margin-right: 2%;
                    }
                    &:nth-child(5){
                        width: 86%;
                        margin-right: 0;
                    }

                }
                textarea{
                    width: 86%;
                    padding:16px 2%;
                    font-size: 18px;
                    color: #6E6D70;
                    line-height: 30px;
                    border: 1px solid #e1e1e1;
                }
            }
            button{
                color: white;
                font-size: 24px;
                background: #52B2F2;
                border:0;
                line-height: 60px;
                width: 40%;
                margin-top: 60px;
            }
        }
    }
</style>
